export const shouldSubmit = queryParams => !(queryParams.isDebug || queryParams.isPreview || queryParams.test);